/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S5_Li5_PreInputs */

const tr_iade_iptal_s5_li5_pre = /** @type {(inputs: Iade_Iptal_S5_Li5_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici sıfatını haiz Aboneler bakımından 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve ilgili yönetmeliklerden doğan haklar (kanunen uygulanabildiği ölçüde cayma hakkı dahil) saklıdır; bu talepler`)
};

const en_iade_iptal_s5_li5_pre = /** @type {(inputs: Iade_Iptal_S5_Li5_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Subscribers who qualify as consumers, the rights arising from Law No. 6502 on the Protection of Consumers and the related regulations (including the right of withdrawal where it applies by law) are reserved; such requests are to be submitted to`)
};

const de_iade_iptal_s5_li5_pre = /** @type {(inputs: Iade_Iptal_S5_Li5_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Abonnenten mit Verbrauchereigenschaft bleiben die Rechte aus dem Gesetz Nr. 6502 über den Verbraucherschutz und den zugehörigen Verordnungen (einschließlich des Widerrufsrechts, soweit es gesetzlich besteht) vorbehalten; solche Anträge sind an`)
};

const ru_iade_iptal_s5_li5_pre = /** @type {(inputs: Iade_Iptal_S5_Li5_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За Абонентами, имеющими статус потребителя, сохраняются права, вытекающие из Закона № 6502 о защите прав потребителей и соответствующих подзаконных актов (включая право на отказ от договора в предусмотренных законом случаях); такие обращения направляются на`)
};

/**
* | output |
* | --- |
* | "For Subscribers who qualify as consumers, the rights arising from Law No. 6502 on the Protection of Consumers and the related regulations (including the righ..." |
*
* @param {Iade_Iptal_S5_Li5_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s5_li5_pre = /** @type {((inputs?: Iade_Iptal_S5_Li5_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S5_Li5_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s5_li5_pre(inputs)
	if (locale === "de") return de_iade_iptal_s5_li5_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s5_li5_pre(inputs)
	return tr_iade_iptal_s5_li5_pre(inputs)
});